import { a as applyMixins } from './apply-mixins.js';
import { O as Observable } from './vivid-element.js';

function applyMixinsWithObservables(derivedCtor, ...baseCtors) {
  applyMixins(derivedCtor, ...baseCtors);
  baseCtors.forEach((baseCtor) => {
    Observable.getAccessors(baseCtor.prototype).forEach((accessor) => {
      Observable.defineProperty(derivedCtor.prototype, accessor.name);
    });
  });
}

export { applyMixinsWithObservables as a };
